import { RSK } from '../types';
export default {
  type: RSK,
  service: 'public',
  url: 'https://public-node.rsk.co',
  port: 443,
  auth: false,
  username: '',
  password: ''
};
